import { PlatformShortcode } from '@/utils/convert-platform'

export const statisticPlatformSupport = {
  viewAnalysis: [
    PlatformShortcode.Facebook,
    PlatformShortcode.Instagram,
    PlatformShortcode.YouTube,
    PlatformShortcode.TikTok,
  ],
  viewRate: [
    PlatformShortcode.Facebook,
    PlatformShortcode.Instagram,
    PlatformShortcode.YouTube,
    PlatformShortcode.TikTok,
    PlatformShortcode.Twitter,
  ],
  metricPerformance: [
    PlatformShortcode.Facebook,
    PlatformShortcode.Instagram,
    PlatformShortcode.YouTube,
    PlatformShortcode.Threads,
  ],
  contentDistribution: [
    PlatformShortcode.Facebook,
    PlatformShortcode.Instagram,
    PlatformShortcode.YouTube,
  ],
  collaborationValueEstimation: [
    PlatformShortcode.Facebook,
    PlatformShortcode.Instagram,
    PlatformShortcode.YouTube,
    PlatformShortcode.TikTok,
    PlatformShortcode.Twitter,
  ],
  avgShareCount: [PlatformShortcode.Facebook, PlatformShortcode.Threads],
  avgRepostAndQuoteCount: [PlatformShortcode.Threads],
  audience: [
    PlatformShortcode.Facebook,
    PlatformShortcode.Instagram,
    PlatformShortcode.YouTube,
    PlatformShortcode.Threads,
  ],
  sponsoredCoverage: [
    PlatformShortcode.Facebook,
    PlatformShortcode.Instagram,
    PlatformShortcode.YouTube,
    PlatformShortcode.Threads,
  ],
}
